import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { AxiosError } from 'axios';

import { DEPOSIT_QUERY_KEY } from '../api/apiConsts';
import { borrowDepositItems, returnDepositItems } from '../api/deposit';
import { BorrowDepositModel } from '../modules/Deposit/model/borrow-deposit-model';
import { DepositRequest } from '../modules/Deposit/model/deposit-request';
import { ReturnDepositModel } from '../modules/Deposit/model/return-deposit-model';

export const useBorrowDepositItems = (): UseMutationResult<
  BorrowDepositModel,
  AxiosError,
  { restaurantId: string; request: DepositRequest }
> => {
  const queryClient = useQueryClient();
  return useMutation(
    ({ restaurantId, request }: { restaurantId: string; request: DepositRequest }) =>
      borrowDepositItems(restaurantId, request),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries(DEPOSIT_QUERY_KEY);
      },
    },
  );
};

export const useReturnDepositItems = (): UseMutationResult<
  ReturnDepositModel,
  AxiosError,
  { restaurantId: string; request: DepositRequest }
> => {
  const queryClient = useQueryClient();
  return useMutation(
    ({ restaurantId, request }: { restaurantId: string; request: DepositRequest }) =>
      returnDepositItems(restaurantId, request),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries(DEPOSIT_QUERY_KEY);
      },
    },
  );
};
